import styled from 'styled-components'

export const AiIconTabEmptyHistoryContainer = styled.section`
  padding: 80px 24px 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`

export const EmptyImageWrapper = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 102px;
  height: 72px;
`

export const EmptyHistoryImg = styled.img<{
  $isImageLoading: boolean
}>`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: ${({ $isImageLoading }) => ($isImageLoading ? 'none' : 'block')};
`
